import { OrganizationDTO } from '~/domain/organization/dto/OrganizationDTO'

export const getPhotoUrl = (dto: OrganizationDTO) => {
  return dto.photo?.url ?? '/images/avatar.png'
}
